module.exports = __webpack_public_path__ + "media/assets/faria_products/MYP-0c3a7089e73867da5d50ad189708b0f12927df15ba5c912e978c0bd659d1bb95.png";